import type { JSX } from 'preact';
import { displayFact, type FactDisplay } from '../lib/facts.ts';

/**
 * One fact's value, laid out from `displayFact` (lib/facts.ts): a line of text, a few lines (an address), a list,
 * a small hours table or a definition list. Never JSON.
 */
export function FactValue({ path, value, class: cls = 'fact-value' }: { path: string; value: unknown; class?: string }): JSX.Element {
  return <FactDisplayView d={displayFact(path, value)} cls={cls} />;
}

function FactDisplayView({ d, cls }: { d: FactDisplay; cls: string }): JSX.Element {
  switch (d.kind) {
    case 'text':
      return <p class={cls}>{d.text}</p>;
    case 'lines':
      return (
        <p class={cls}>
          {d.lines.map((l, i) => (
            <span key={i} class="fact-line">{l}</span>
          ))}
        </p>
      );
    case 'list':
      return (
        <ul class={`${cls} fact-list`}>
          {d.items.map((x, i) => <li key={i}>{x}</li>)}
        </ul>
      );
    case 'table':
      return (
        <table class={`${cls} fact-table`}>
          <tbody>
            {d.rows.map(([k, v]) => (
              <tr key={k}>
                <th scope="row">{k}</th>
                <td>{v}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    case 'pairs':
      return (
        <dl class={`${cls} fact-pairs`}>
          {d.rows.map(([k, v]) => (
            <div key={k} class="fact-pair">
              <dt>{k}</dt>
              <dd>{v}</dd>
            </div>
          ))}
        </dl>
      );
  }
}
